// react
import { useMemo } from 'react';
import styled from 'styled-components';

/**
 * CarouselIndicator shows dots where only one is highlighted.
 */
export const CarouselIndicator = ({
  total,
  index,
  color = 'dark',
}: CarouselIndicatorProps) => {
  const dots = useMemo(() => {
    let tmpArray: number[] = [];
    for (let i = 0; i < total; i++) {
      tmpArray.push(i);
    }
    return tmpArray;
  }, [total]);

  return (
    <Wrapper>
      {dots.map((dot: number) => (
        <IndicatorDot key={dot} $isHighlighted={dot === index} $color={color} />
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing[12]};
`;

interface IndicatorDotProps {
  $isHighlighted: boolean;
  $color: CarouselIndicatorColor;
}
const IndicatorDot = styled.div<IndicatorDotProps>`
  min-width: 14px;
  width: 14px;
  max-width: 14px;
  min-height: 14px;
  height: 14px;
  max-height: 14px;
  border-radius: 99999px;
  transition-duration: 0.2s;
  background: ${(props) => {
    if (props.$isHighlighted) {
      return props.theme.color.primary[80];
    } else {
      switch (props.$color) {
        case 'light':
          return props.theme.color.neutral[10];
        case 'dark':
        default:
          return props.theme.color.neutral[60];
      }
    }
  }};
`;

type CarouselIndicatorColor = 'light' | 'dark';

interface CarouselIndicatorProps {
  total: number;
  index: number;
  color?: CarouselIndicatorColor;
}

CarouselIndicator.displayName = 'CarouselIndicator';

export default CarouselIndicator;
